import DeprecatedApiClient, {
  RESPONSE_TYPE,
} from '../../../packages/neb-api-client/src/utils/api-client-utils';

export const BASE_URL = 'booking/statements';

export const billingApiClient = new DeprecatedApiClient({
  microservice: 'billing',
});

export const getStatementFromS3 = async statementId => {
  const path = `${BASE_URL}/${statementId}`;

  const response = await billingApiClient.makeRequest({
    optOutLoadingIndicator: false,
    path,
    version: 1,
    responseType: RESPONSE_TYPE.RAW,
  });

  return response.arrayBuffer();
};
